import React from "react";
import { CardFrameType, StatsDataType } from "../../../type";
import { FieldStyled } from "./LeftSideMenuUploadCards.styled";
import { CARD_CONDITIONS_CARDTRADER } from "../../../constant";
import {
  LabelStyled,
  PrimaryButton,
  StyledInput,
  StyledSelect,
  TitleStyle,
} from "../../common/common.style";
import { FlexBox, Option } from "../../primitives";
import { CheckBox } from "../../common/CheckBox/CheckBox";
import {
  CardTraderConditionValueType,
  CardTraderLanguageValueType,
} from "magic-shared-types";
import { Modal } from "../../common/Modal/Modal";
import { useSelector } from "react-redux";
import { selectGame } from "../../../store/slices/global";

interface ModalChangeDefaultValueProps {
  setDefaultStatsValue: (arg1: StatsDataType) => void;
  defaultStatsValue: StatsDataType;
  setIsOpenModalDefaultValue: (arg1: boolean) => void;
}

export const ModalChangeDefaultValue = ({
  setDefaultStatsValue,
  defaultStatsValue,
  setIsOpenModalDefaultValue,
}: ModalChangeDefaultValueProps) => {
  const game = useSelector(selectGame);
  const hasFoil = !["yugioh", "onepiece", "pokemon"].includes(
    game.card_trader_game
  );
  const hasFirstEdition = ["yugioh", "pokemon"].includes(game.card_trader_game);
  const hasReverse = ["pokemon"].includes(game.card_trader_game);

  return (
    <Modal onClose={() => setIsOpenModalDefaultValue(false)}>
      <TitleStyle css={{ fontSize: 16, marginTop: 20 }}>
        DEFAULT VALUE
      </TitleStyle>
      <FlexBox css={{ gap: 20, flexWrap: "wrap", "@smRev": { gap: 0 } }}>
        <FieldStyled>
          <LabelStyled>Quantity</LabelStyled>
          <StyledInput
            type="number"
            value={defaultStatsValue.quantity}
            onChange={(e) =>
              setDefaultStatsValue({
                ...defaultStatsValue,
                quantity: +e.target.value,
              })
            }
            onKeyDown={(e) => {
              if (["e", "E", "+", "-"].includes(e.key)) {
                e.preventDefault();
              }
            }}
          />
        </FieldStyled>

        <FieldStyled>
          <LabelStyled>Price</LabelStyled>
          <StyledInput
            type="number"
            value={defaultStatsValue.price}
            onChange={(e) =>
              setDefaultStatsValue({
                ...defaultStatsValue,
                price: +e.target.value,
              })
            }
            onKeyDown={(e) => {
              if (["e", "E", "+", "-"].includes(e.key)) {
                e.preventDefault();
              }
            }}
          />
        </FieldStyled>

        <FieldStyled>
          <LabelStyled>Commments</LabelStyled>
          <StyledInput
            type="text"
            value={defaultStatsValue.description}
            onChange={(e) =>
              setDefaultStatsValue({
                ...defaultStatsValue,
                description: e.target.value,
              })
            }
          />
        </FieldStyled>
      </FlexBox>
      <FlexBox css={{ gap: 20, flexWrap: "wrap" }}>
        <FieldStyled>
          <LabelStyled>Condition</LabelStyled>
          <StyledSelect
            value={defaultStatsValue.condition}
            onChange={(e) =>
              setDefaultStatsValue({
                ...defaultStatsValue,
                condition: e.target.value as CardTraderConditionValueType,
              })
            }
          >
            {CARD_CONDITIONS_CARDTRADER?.map((condition) => (
              <Option value={condition.value}>
                {condition.value} {`(${condition.code})`}
              </Option>
            ))}
          </StyledSelect>
        </FieldStyled>

        <FieldStyled>
          <LabelStyled>Language</LabelStyled>
          <StyledSelect
            value={defaultStatsValue.language}
            onChange={(e) =>
              setDefaultStatsValue({
                ...defaultStatsValue,
                language: e.target.value as CardTraderLanguageValueType,
              })
            }
          >
            <Option value="en">🇬🇧 English</Option>
            <Option value="fr">🇫🇷 French</Option>
            <Option value="de">🇩🇪 German</Option>
            <Option value="es">🇪🇸 Spanish</Option>
            <Option value="it">🇮🇹 Italian</Option>
            <Option value="zn-ch">🇨🇳 Simplified Chinese</Option>
            <Option value="jp">🇯🇵 Japanese</Option>
            <Option value="pt">🇵🇹 Portuguese</Option>
            <Option value="ru">🇷🇺 Russian</Option>
            <Option value="kr">🇰🇷 Korean</Option>
            <Option value="zh-tw">🇹🇼 Traditional Chinese</Option>
          </StyledSelect>
        </FieldStyled>

        {hasFoil && (
          <FieldStyled>
            <LabelStyled>Finish type</LabelStyled>
            <StyledSelect
              value={defaultStatsValue.finish}
              onChange={(e) =>
                setDefaultStatsValue({
                  ...defaultStatsValue,
                  finish: e.target.value as CardFrameType,
                })
              }
            >
              <Option value="regular">regular</Option>
              <Option value="foil">foil</Option>
            </StyledSelect>
          </FieldStyled>
        )}

        {hasFirstEdition && (
          <FlexBox css={{ alignItems: "center", gap: 10 }}>
            <LabelStyled>First Edition</LabelStyled>
            <CheckBox
              checked={defaultStatsValue.isFirstEdition}
              setChecked={(checked: boolean) => {
                setDefaultStatsValue({
                  ...defaultStatsValue,
                  isFirstEdition: checked,
                });
              }}
            />
          </FlexBox>
        )}

        {hasReverse && (
          <FlexBox css={{ alignItems: "center", gap: 10 }}>
            <LabelStyled>Reverse</LabelStyled>
            <CheckBox
              checked={defaultStatsValue.isReversed}
              setChecked={(checked: boolean) => {
                setDefaultStatsValue({
                  ...defaultStatsValue,
                  isReversed: checked,
                });
              }}
            />
          </FlexBox>
        )}

        <FlexBox css={{ alignItems: "center", gap: 10 }}>
          <LabelStyled>Signed</LabelStyled>
          <CheckBox
            checked={defaultStatsValue.signed}
            setChecked={(checked: boolean) => {
              setDefaultStatsValue({
                ...defaultStatsValue,
                signed: checked,
              });
            }}
          />
        </FlexBox>
      </FlexBox>

      <FlexBox css={{ justifyContent: "center", marginTop: 20 }}>
        <PrimaryButton onClick={() => setIsOpenModalDefaultValue(false)} isBig>
          DONE
        </PrimaryButton>
      </FlexBox>
    </Modal>
  );
};
